import { portalBonusCampaignsApiMock } from "@/data/portal_bonus_campaigns_mock";

export function toBonusUhrdWidgetData(program) {
  const goal = Number(program.goal);
  const currentUnits = Number(program.currentUnits) || 0;
  const goalAchieved =
    program.goalAchieved === true ||
    (program.goalAchieved !== false &&
      Number.isFinite(goal) &&
      currentUnits >= goal);

  return {
    currentUnits: program.currentUnits,
    goal: program.goal,
    pointsLabelKey: program.pointsLabelKey,
    levels: program.levels,
    goalAchieved,
    beyondGoalPointsLabelKey: program.beyondGoalPointsLabelKey ?? null,
    goalAchievedLabelKey:
      program.goalAchievedLabelKey ?? "portalHome.bonusUhrd.goalAchievedLabel",
    goalBarPositionPct: program.goalBarPositionPct,
  };
}

function isFirstMilestoneAchieved(program) {
  if (program.firstMilestoneAchieved === true) return true;
  if (program.firstMilestoneAchieved === false) return false;
  const first = program.milestones?.[0]?.threshold;
  const current = Number(program.currentUnits) || 0;
  return Number.isFinite(first) && current >= first;
}

export function toBonusAwansWidgetData(program) {
  return {
    currentUnits: program.currentUnits,
    goal: program.goal,
    maxUnits: program.maxUnits,
    milestones: program.milestones,
    firstMilestoneAchieved: isFirstMilestoneAchieved(program),
  };
}

function firstMilestoneThreshold(program) {
  const first = program.milestones?.[0]?.threshold;
  if (Number.isFinite(first)) return first;
  const g = Number(program.goal);
  return Number.isFinite(g) ? g : 0;
}

export function remainingUnitsToGoal(program) {
  if (Number.isFinite(program.remainingUnitsToGoal)) {
    return Math.max(0, program.remainingUnitsToGoal);
  }
  const current = Number(program.currentUnits) || 0;
  const milestones = program.milestones;
  if (Array.isArray(milestones) && milestones.length) {
    const first = milestones[0]?.threshold;
    if (Number.isFinite(first) && current >= first) {
      const next = milestones.find((m) => current < Number(m.threshold));
      if (next) return Math.max(0, Number(next.threshold) - current);
    }
  }
  const target =
    program.levels != null ? Number(program.goal) : firstMilestoneThreshold(program);
  if (!Number.isFinite(target)) return 0;
  return Math.max(0, target - current);
}

export function toGoalReminder(program, period = portalBonusCampaignsApiMock.period) {
  const goal = Number(program.goal);
  const currentUnits = Number(program.currentUnits) || 0;
  const goalAchieved =
    program.goalAchieved === true ||
    (program.goalAchieved !== false &&
      Number.isFinite(goal) &&
      currentUnits >= goal);

  const firstMilestoneAchieved =
    program.milestones != null && isFirstMilestoneAchieved(program);

  return {
    remainingUnits: remainingUnitsToGoal(program),
    daysRemaining: period.daysRemaining,
    goalAchieved,
    firstMilestoneAchieved,
    beyondGoalTotalPointsLabelKey: program.beyondGoalTotalPointsLabelKey ?? null,
  };
}

/** @param {string} programKey @param {{ heroSrc: string, toolbarIconKey: string }} pageMeta */
export function buildPortalBonusCampaignPageView(
  programKey,
  pageMeta,
  api = portalBonusCampaignsApiMock
) {
  const program = api.programs[programKey];
  if (!program || !pageMeta) return null;

  const isUhrd = program.levels != null;

  return {
    heroSrc: pageMeta.heroSrc,
    toolbarIconKey: pageMeta.toolbarIconKey,
    account: {
      balance: api.account.balance,
      updatedAt: api.account.updatedAt,
      purchases: api.account.purchases.map((row) => ({ ...row })),
    },
    bonusDetail: isUhrd ? toBonusUhrdWidgetData(program) : toBonusAwansWidgetData(program),
    goalReminder: toGoalReminder(program, api.period),
  };
}
